import { useContext } from 'react';
import { store } from '../Context/Store';

const useStoriesStatic = (ids) => {
  const {
    globalState: { siteData },
  } = useContext(store);

  const storiesList = siteData.allGeneral;

  const storiesFound = storiesList.filter((story, index) =>
    ids.includes(story.id)
  );

  return storiesFound;
};

export default useStoriesStatic;
